export type RuntimeConfig = {
  ASSET_SERVER: string;
  PROVIDER_DIRECTORY_SDK: string;
  GRID_LICENSE_KEY: string;
  /** PDF license secret (not the sessionStorage key name). */
  LICENSE_STORAGE_KEY: string;
  /** BFF path prefixing: 'true' | 'false' | '' (inherit). */
  USE_API_PROXY_ROUTES: string;
  /** Case Accelerator two-phase UI: 'true' | 'false' | '' (off). */
  CASE_ACCELERATOR_UI_ENABLED: string;
  /** Console log verbosity: DEBUG | INFO | WARN | ERROR | NO_LOG | '' (inherit default WARN). */
  UI_LOG_LEVEL: string;
  /** Seconds between periodic session heartbeat POSTs while signed in. */
  SESSION_HEARTBEAT_INTERVAL_SECONDS: string;
  /** Session-first auth cutover: 'true' | 'false' | '' (off). Also gates POST /session/renew. */
  FRONTEND_SESSION_FIRST: string;
};

export type RuntimeConfigSnapshot = RuntimeConfig;

declare global {
  interface Window {
    RUNTIME_CONFIG?: Partial<RuntimeConfig>;
    BUILD_CONFIG?: {
      GRID_LICENSE_KEY?: string;
      LICENSE_STORAGE_KEY?: string;
      DATADOG_ID?: string;
      BUILD_ID?: string;
    };
  }
}

export const DEFAULT_RUNTIME_CONFIG: RuntimeConfig = {
  ASSET_SERVER: '',
  PROVIDER_DIRECTORY_SDK: '1.5.9',
  GRID_LICENSE_KEY: '',
  LICENSE_STORAGE_KEY: '',
  USE_API_PROXY_ROUTES: '',
  CASE_ACCELERATOR_UI_ENABLED: '',
  UI_LOG_LEVEL: '',
  SESSION_HEARTBEAT_INTERVAL_SECONDS: '30',
  FRONTEND_SESSION_FIRST: '',
};
